<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>ELM</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image" /></div>
</div>

<div class="courses-area ptb-100 bg-f5f7fa">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="about-text-container">
                    <h4
                        style="
                            background: #29176d;
                            color: white;
                            padding: 21px;
                            margin-bottom: 15px;
                        "
                    >
                        ELM
                    </h4>

                    <b>
<ol>
    
                       <li><a href="elm/MA-Budd"
                                            target="_blank"
                                            class="nav-link"
                                            routerLinkActive="active"
                            class="hover-underline-animation"
                            >MA (Buddhist)</a
                        ></li> <br />
                        <li>
                            <a
                                href="elm/MBA-ELM"
                                            target="_blank"
                                            class="nav-link"
                                            routerLinkActive="active"
                            class="hover-underline-animation"
                                >MBA</a
                            >
                        </li>
</ol>
                    </b>
                  
                </div>
            </div>
        </div>
    </div>
</div>
